var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('span',{staticClass:"block text-red-800 dark:text-red-300"},[_vm._v(_vm._s(_vm.error))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }